import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import VisaPrepActivate, { IDispatchProps, IProps } from './index';
import { ApplicationState } from '../../../../store';
import { saveMessage, saveVisaPrepForm } from '../../../../store/student/actions';
import { Pages } from '../../../../store/student/visaPrepForm/types';
import { getDisplayName } from '../../../../utilities/formatting';
import { IMessage } from 'api-paths-cas';

const mapStateToProps = (state: ApplicationState, ownProps: { onClose: () => void }): IProps => {
  return {
    userName: state.auth.student_number!,
    displayName: getDisplayName(state.auth, state.config),
    onClose: ownProps.onClose,
    role: state.auth.role,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  onSubmitMessage: (message: IMessage) => {
    dispatch(saveMessage(message));
    dispatch(saveVisaPrepForm(Pages.VISA_UNLOCK));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(VisaPrepActivate);
